import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import DiallerKeyPad from "../Dialler/DiallerKeyPad";
import { notifyInvalidPhone } from "../components/Utils";
import classNames from "classnames";
import { makeCall } from "../../../state/actions/phone";
import KeypadCallModal from "../../../components/ui/Modals/ModalMessages/KeypadCallModal";
import { useOnlineStatus } from "../../../services/customHooks/useOnlineStatus";
const R = require("ramda");

const DiallerPadButton = () => {
	const [openDialPad, setOpenDialPad] = useState(false);
	const [dialPadToolTipOpen, setDialPadToolTipOpen] = useState(false);
	const [isPostpaidUser, setIsPostpaidUser] = useState({});

	const dispatch = useDispatch();

	// Redux selectors
	const userId = useSelector((state) => state.user?.user?.userId);
	const isUserOnline = useOnlineStatus();
	const emailAddress = useSelector((state) => state.user?.user?.emailAddress);
	const balance = useSelector((state) => state.user.balance);
	const postpaidStatus = useSelector((state) => state.user.voipStatus || false);
	const selectedDomain = useSelector((state) => state.domain.selectedDomain);

	useEffect(() => {
		if (postpaidStatus) {
			setIsPostpaidUser({ ...postpaidStatus });
		}
	}, [postpaidStatus]);

	const showCreateConversation = () => setOpenDialPad(true);
	const closeCreateConversation = () => setOpenDialPad(false);

	const noBalance = () => {
		closeCreateConversation();
		// You may want to dispatch a noBalance action here if applicable
	};

	const makePhoneCall = useCallback(
		async (phone, callMode) => {
			if (R.isNil(phone)) {
				notifyInvalidPhone();
				return;
			}

			if (!isPostpaidUser.isPostpaidUser && balance <= 0) {
				noBalance();
				return;
			}

			const mode = callMode === "sat" ? "sat" : "phone";
			dispatch(
				makeCall(mode, emailAddress, phone, phone, null, null, "on-call")
			);
		},
		[isPostpaidUser, balance, emailAddress, dispatch]
	);

	const userDomain = selectedDomain || "";

	return (
		<div className="home-call-btn flex items-center relative" id="dialPad">
			<a
				onClick={showCreateConversation}
				onMouseEnter={() => setDialPadToolTipOpen(true)}
				onMouseLeave={() => setDialPadToolTipOpen(false)}
				className={classNames(
					"btn btn-default flex items-center justify-center cursor-pointer",
					{ disabled: !isUserOnline }
				)}
			>
				<img
					src="/img/dialerPad.png"
					width={"22px"}
				/>

			</a>
			{dialPadToolTipOpen &&
				<div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 z-50 bg-gray-900 z-[99999999] overflow-hidden bg-header-bg rounded-lg">
					{/* Tooltip content */}
					<div
						className={`relative bg-gray-900 text-sm rounded-lg px-3 py-2 shadow-lg whitespace-nowrap transition-opacity duration-200 border  border-gray-700 ${userDomain}_font`}
					>
						Dialpad

						{/* Tooltip arrow */}
						<div className="absolute -top-1.5 left-1/2 transform -translate-x-1/2">
							<div className="w-0 h-0 border-l-4 border-r-4 border-b-4 border-l-transparent border-r-transparent border-b-gray-900"></div>
						</div>
					</div>
				</div>}
			{openDialPad && (
				<KeypadCallModal size="sm" noHeader className="dialler-modal p-0 overflow-hidden">
					<DiallerKeyPad
						makePhoneCall={makePhoneCall}
						onClose={closeCreateConversation}
						noBalance={noBalance}
					/>
				</KeypadCallModal>
			)}
		</div>
	);
};

export default DiallerPadButton;
